import React from 'react';

import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { BreadcrumbStateInfo } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbStateInfo';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { getAppStore } from '../../app/AppStore';
import { ServerUrls } from '../../app/ServerUrls';
import { ConnectedQueryParamUpdateProvider } from '../../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { Messages } from '../../codegen/Localize';
import { ConnectedAllSchedulesSpace } from './ConnectedAllSchedulesSpace';

export interface AllSchedulesSpaceProviderProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls | ServerUrls;
}

const AllSchedulesSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'schedules',
  subspaceName: undefined
};

export const AllSchedulesSpaceProvider: React.FunctionComponent<AllSchedulesSpaceProviderProps> = (props) => {

  React.useEffect(
    () => {
      getAppStore().dispatch(
        updateBreadcrumbs([getSchedulesPlaceBreadcrumb(props.urls)])
      );
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllSchedulesSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={false}
        shouldUpdateSort={true}
      >
        <ConnectedAllSchedulesSpace
          siteName={props.siteName}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export function getSchedulesPlaceBreadcrumb(urls: SpacesSiteUrls | ServerUrls): BreadcrumbStateInfo {
  const href = urls.schedulesUrl();
  return {
    id: href,
    text: Messages.allSchedules(),
    href: href,
    testId: 'schedules-link'
  };
}
